/**
 * Custom Element für page_view DataLayer Events
 *
 * Reiner Datencontainer für pageview-bezogene Attribute.
 * Die Logik zum Sammeln und Pushen übernimmt der PageviewHandler.
 *
 * Verwendung:
 * <dl-pageview page-title="Home" page-location="/home"></dl-pageview>
 */
export default class DlPageview extends HTMLElement {
    static get tag() {
        return "dl-pageview";
    }

    static {
        if (!customElements.get(DlPageview.tag)) {
            customElements.define(DlPageview.tag, DlPageview);
        }
    }

    /**
     * Sammelt alle Attribute dieses Elements als Key-Value-Objekt
     * @returns {Object} Objekt mit allen Attributen als key-value Paare
     */
    get params() {
        const attributes = {};

        if (!this.attributes) {
            return attributes;
        }

        // Iteriere über alle Attribute des Elements
        for (let i = 0; i < this.attributes.length; i++) {
            const attr = this.attributes[i];
            attributes[attr.name] = attr.value;
        }

        return attributes;
    }
}
